<template>
  <div :class="s.background" v-sound>
    <div :class="s.title">
      <div>
        <img :class="s.productImage" src="/img/menu/staff.png" alt="注文画像" />
      </div>
      <p>スタッフをお呼びしました</p>
      <div :class="s.subtitle">
        <p>しばらくお待ちください</p>
      </div>
      <div :class="s.container">
        <button :class="s.closeButton" @click="goToMenu">メニューに戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToMenu() {
      if (window.innerWidth <= 768) {
        this.$router.push('/menu-mobile');
      } else {
        this.$router.push('/menu');
      }
    },
  },
};
</script>

<style lang="scss" module="s">
.background {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ✅ 画像スタイル */
.productImage {
  width: 55vw;
  height: 55vh;
  object-fit: contain;
  margin-bottom: -8vh;
}

/* ✅ タイトルとメッセージ */
.title {
  color: #836131;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 70px;
  text-align: center;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50px);
  white-space: nowrap;
}

/* ✅ サブタイトル */
.subtitle {
  color: #836131;
  font-family: '游明朝', serif;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 20px;
}

/* ✅ ボタンコンテナ */
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3vh;
}

/* ✅ トップに戻るボタン */
.closeButton {
  background-color: #B03A2E;
  color: #FFFFFF;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 3vw;
  padding: 5vh 10vw;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  outline: none;
}

.closeButton:hover {
  background-color: #A32A2E;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .title {
    font-size: 32px; /* モバイルでのタイトルサイズ縮小 */
  }
  .subtitle {
    font-size: 24px; /* モバイルでのサブタイトルサイズ縮小 */
  }
  .closeButton {
    font-size: 24px; /* モバイルでのボタン文字サイズ調整 */
    padding: 16px 60px; /* タップしやすいようにパディング調整 */
  }
  .productImage {
    width: 70vw; /* モバイル画像サイズ調整 */
    height: 40vh;
  }
}
</style>
